import React from "react";

import NonResidentTicketOptions from "./NonResidentTicketOptions";

// GuestTicketSelector component (used to pick guest tickets)
const GuestTicketSelector = (props) => {
    const {isWAResident, isMember, maxTickets, todaysTicketData, seats, selectedTime, selectedTimeIndex, selectedTickets, setSelectedTickets} = props;

    return (
        <div className="guest-ticket-selector">
            <h4>Select Guests</h4>
            <p>All youth and children must be accompanied by an adult. Children ages 3 and under require tickets—but they’re free!</p>
            <div className="guest-ticket-selector__options">
                <NonResidentTicketOptions
                    isWAResident={isWAResident}
                    isMember={false}
                    maxTickets={maxTickets}
                    todaysTicketData={todaysTicketData}
                    seats={seats}
                    selectedTime={selectedTime}
                    selectedTimeIndex={selectedTimeIndex}
                    selectedTickets={selectedTickets}
                    setSelectedTickets={setSelectedTickets}
                />
            </div>
        </div>
    );
}

export default GuestTicketSelector;